export default __webpack_public_path__ + "e7389df6d32510035a4acc680f5eafd3.svg";